import { render } from "./GameSelect.vue?vue&type=template&id=4e6037ec&scoped=true"
import script from "./GameSelect.vue?vue&type=script&lang=js"
export * from "./GameSelect.vue?vue&type=script&lang=js"

import "./GameSelect.vue?vue&type=style&index=0&id=4e6037ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e6037ec"

export default script